"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Wall = void 0;
const PIXI = __importStar(require("pixi.js"));
const IsoPoint_1 = require("../../../engine/lib/IsoPoint");
class Wall extends PIXI.Sprite {
    constructor(texture, iso = new IsoPoint_1.IsoPoint(), direction = 0) {
        super(texture);
        this.iso = iso;
        this.direction = direction;
        // this.interactive = true
        // this.buttonMode = true
        // this.width = 88
        // this.height = 200
        iso.toPoint().copyTo(this.position);
    }
}
exports.Wall = Wall;
